angular.
module("dx.webapp.lists").
controller("DxExamEntryController", function ExamEntryController(
	$rootScope,
	$timeout,
	$element,
	$location,

	examStatus,
	DX_URLS,
	ExamRepository,
	DX_EXAMS_STEPS,
	faults,
	dxScrollIntoView,
	dxApi,
	DX_SHARE,
	dxSession,
	RoleTypeEnum,
	DX_INVIGILATOR_SETTINGS,
	DX_EXAM_PARTS,
	DX_PRINT_SETTINGS,
	DX_PAGE_BREAK,

	dxDialog,
	dxLocalize
) {
	"use strict";

	var self = this;

	self.Urls = DX_URLS;
	self.dxApi = dxApi;

	self.dxSession = dxSession;
	self.RoleTypeEnum = RoleTypeEnum;

	self.DX_INVIGILATOR_SETTINGS = DX_INVIGILATOR_SETTINGS;

	if (self.exam.groupId !== 0 && self.dxSession.getRole().roleType !== RoleTypeEnum.INVIGILATOR) {
		// Only load groups that belong to the same organization.
		if (self.exam.organizationId === self.dxSession.getRole().organizationId) {
			dxApi.v1.groups.get([self.exam.groupId]).then(function onSuccess(response) {
				self.skolonGroup = response.data[0].integrationSource === 3;
			});
		}
	}

	if (self.recentlyTouched) {
		// This timeout will run when the element has entered the DOM.
		$timeout(function timeout() {
			dxScrollIntoView(angular.element("[ng-view]"), $element);
		});
	}

	/* State helpers */

	self.isTemplate = function isTemplate() {
		return self.exam.isTemplate();
	};

	self.isScheduled = function isScheduled() {
		return self.exam.examStatus === examStatus.PLANNED || self.exam.isUnplanned();
	};

	self.isActive = function isActive() {
		return self.exam.examStatus === examStatus.ACTIVE;
	};

	self.isUngraded = function isUngraded() {
		return self.exam.examStatus === examStatus.NOT_GRADED;
	};

	self.isGraded = function isGraded() {
		return self.exam.examStatus === examStatus.GRADED;
	};

	self.isPublished = function isPublished() {
		return self.exam.examStatus === examStatus.PUBLISHED;
	};

	self.isShared = function isShared() {
		return !self.exam.hasOwnerRights() && self.exam.sharedBy;
	};

	self.examPrintUrl = DX_URLS.get("examPrint", {
		id: self.exam.id,
		examParts: DX_EXAM_PARTS.EXAM_PRINT_PARTS,
		printSettings: DX_PRINT_SETTINGS.DEFAULT,
		pageBreakBefore: DX_PAGE_BREAK.NO_PAGE_BREAK,
	});

	// The importedFromQTI property will be set in WEB-2062
	self.isImported = function isImported() {
		return self.exam.importedFromQTI;
	};

	/* Actions */

	self.defaultActionUrl = function defaultActionUrl() {
		var defaultActionUrls = [
			{match: self.isTemplate(), url: DX_URLS.get("examEdit", self.exam)},
			{match: self.isScheduled(), url: DX_URLS.get("examView", self.exam)},
			{match: self.isActive(), url: DX_URLS.get("examView", self.exam)},
			{match: self.isUngraded(), url: DX_URLS.get("examGrades", self.exam)},
			{match: self.isGraded(), url: DX_URLS.get("examGrades", self.exam)},
			{match: self.isPublished(), url: DX_URLS.get("examGrades", self.exam)},
		];

		var urlMatches = defaultActionUrls.filter(function match(defActionUrl) {
			return defActionUrl.match ? defActionUrl.url : null;
		});

		return urlMatches.length ? "#" + urlMatches[0].url : "#";
	};

	self.removeExam = function removeExam() {
		var scope = $rootScope.$new();
		scope.requestInProgress = false;
		scope.examTitle = self.exam.title;
		scope.close = dxDialog.closeMostRecent;

		scope.remove = function remove() {
			scope.requestInProgress = true;

			ExamRepository.erase(self.exam.id).then(function success() {
				dxDialog.closeMostRecent();
				$rootScope.$broadcast("notification:success", dxLocalize.get("RemovedExamX", self.exam.title));
				removeExamFromList(self.exam, DX_EXAMS_STEPS.scheduled);
			}, function failed() {
				dxDialog.closeMostRecent();
				$rootScope.$broadcast("notification:error", dxLocalize.get("CouldNotRemoveExamX", self.exam.title));
			});
		};

		dxDialog.show({
			templateUrl: "tmpl/lists/remove-exam-popup.html",
			$scope: scope,
			escapeToClose: false,
			clickOutsideToClose: false,
		});
	};

	self.moveExam = function moveExam() {
		var strippedScope = $rootScope.$new();
		strippedScope.exam = self.exam;
		dxDialog.show({
			templateUrl: "/partials/popups/move-exam.html",
			$scope: strippedScope,
			escapeToClose: false,
			clickOutsideToClose: false,
		});
	};

	self.scheduleExam = function scheduleExam(startNow) {
		var scope = $rootScope.$new();
		scope.exam = self.exam;
		scope.schedule = !startNow;
		scope.groupTitle = self.groupTitle;
		scope.examCreatedCallback = function examCreatedCallback(examCreated) {
			if (self.isTemplate()) {
				if (startNow) {
					addExamToList(examCreated, DX_EXAMS_STEPS.ongoing);
				} else {
					addExamToList(examCreated, DX_EXAMS_STEPS.scheduled);
				}
			} else if (self.isScheduled()) {
				if (startNow) {
					addExamToList(examCreated, DX_EXAMS_STEPS.ongoing);

					// If the exam was previously scheduled but was 'started now'
					// we need to remove it from the scheduled list.
					removeExamFromList(self.exam, DX_EXAMS_STEPS.scheduled);
				} else {
					self.exam = examCreated;
				}
			}
		};

		dxDialog.show({
			templateUrl: "tmpl/exams/start-exam-popup.html",
			$scope: scope,
			escapeToClose: false,
			clickOutsideToClose: false,
		});
	};


	self.shareExam = function shareExam() {
		var popupScope = $rootScope.$new();
		popupScope.sharedToUser = [];
		popupScope.item = {
			displayName: self.exam.title,
			ownerId: self.exam.userId,
		};
		popupScope.examId = self.exam.id;
		popupScope.type = DX_SHARE.EXAM_TEMPLATES;

		dxApi.v1.examTemplates.shares.get(self.exam.id).then(function onReturn(response) {
			popupScope.sharedToUser = response.data.users || [];
			popupScope.ownerName = response.data.ownerName;
		});

		popupScope.confirm = function confirm() {
			var shareItemControllerScope = this; // eslint-disable-line consistent-this
			shareItemControllerScope.loading = true;

			function successHandler(response) {
				shareItemControllerScope.loading = false;

				if (!response.faults) {
					shareItemControllerScope.close();
					$rootScope.$broadcast(
						"notification:success",
						dxLocalize.get("YouSharedXWithY", shareItemControllerScope.item.displayName, shareItemControllerScope.email)
					);
				} else if (response.faults.indexOf(faults.USER_NOT_FOUND) >= 0) {
					shareItemControllerScope.error = "ForgotPassword.Fail.EmailNotFound";
				} else if (response.faults.indexOf(faults.FORBIDDEN) >= 0) {
					shareItemControllerScope.error = "CouldNotShareCantHandleExams";
				} else {
					$rootScope.$broadcast("notification:error", dxLocalize.get("Feedback.FailedToShareExam"));
				}
			}

			function errorHandler() {
				shareItemControllerScope.loading = false;
				$rootScope.$broadcast("notification:error", dxLocalize.get("Feedback.FailedToShareExam"));
			}

			return self.exam.libraryShareWith(shareItemControllerScope.email).then(successHandler).catch(errorHandler);
		};

		dxDialog.show({
			templateUrl: "partials/popups/share-item.html",
			$scope: popupScope,
		});
	};

	self.archiveExam = function archiveExam() {
		self.exam.isArchived = true;
		//This represent our maximum hours limit 9999h - fix for old exam with huge time limits
		if (self.exam.duration > 3.59964e+16) {
			self.exam.duration = 3.59964e+16;
		}
		if (self.isScheduled()) {
			dxDialog.confirm({
				title: dxLocalize.get("Schedule.Exam.Archive.Title", self.exam.title),
				body: dxLocalize.get("Schedule.Exam.Archive.Text"),
				acceptText: dxLocalize.get("Archive"),
				acceptCallback: saveExam,
				rejectText: dxLocalize.get("Cancel"),
			});
		} else {
			saveExam();
		}
	};

	function saveExam() {
		function successHandler() {
			removeExamFromList(self.exam, DX_EXAMS_STEPS.library);
			removeExamFromList(self.exam, DX_EXAMS_STEPS.scheduled);
			removeExamFromList(self.exam, DX_EXAMS_STEPS.ongoing);
			removeExamFromList(self.exam, DX_EXAMS_STEPS.ungraded);
			removeExamFromList(self.exam, DX_EXAMS_STEPS.graded);
			removeExamFromList(self.exam, DX_EXAMS_STEPS.published);
			$rootScope.$broadcast("notification:success", dxLocalize.get("Feedback.SuccessArchived"));
			dxDialog.closeMostRecent();
		}

		function errorHandler() {
			$rootScope.$broadcast("notification:error", dxLocalize.get("Feedback.ErrorArchiving"));
			self.exam.isArchived = false;
		}

		ExamRepository.save(self.exam).then(successHandler).catch(errorHandler);
	}

	self.removeShare = function removeShare() {
		function remove() {
			ExamRepository.removeShare(self.exam).then(function success(response) {
				if (!response) {
					$rootScope.$broadcast("notification:error", dxLocalize.get("Feedback.CouldNotRemoveShare"));
				}
				removeExamFromList(self.exam, DX_EXAMS_STEPS.library);
			});

			return dxDialog.closeMostRecent();
		}

		return dxDialog.confirm({
			title: dxLocalize.get("RemoveSharedExam"),
			body: dxLocalize.get("ThePersonWhoSharedTheExamWillStillHaveAccessToIt"),
			acceptText: dxLocalize.get("RemoveExam"),
			acceptCallback: remove,
			rejectText: dxLocalize.get("Cancel"),
		});
	};

	self.toggleDropdown = function closeDropdown(event, actionFunction) {
		event.stopPropagation();
		$element.find(".dropdown_menu").dropdown("toggle");

		if (actionFunction) {
			actionFunction();
		}
	};

	self.editExam = function editExam() {
		function routeToExam() {
			dxDialog.closeMostRecent();
			$location.path(DX_URLS.get("examEdit", self.exam));
		}

		dxApi.v1.examTemplates.exams.get(self.exam.id).then(function onSuccess(response) {
			var childExamIds = response.data;
			if (!childExamIds || childExamIds.length === 0) {
				routeToExam();
				return;
			}

			dxDialog.confirm({
				title: dxLocalize.get("EditExamPopup.ExistingExams.Title"),
				body: dxLocalize.get("EditExamPopup.ExistingExams.Body"),
				acceptText: dxLocalize.get("Action.Continue"),
				acceptCallback: routeToExam,
				rejectText: dxLocalize.get("Cancel"),
			});
		}, function onError() {
			routeToExam();
		});
	};

	self.argumentWrapper = function functionWrapper(actionFunction) {
		var argumentList = Array.prototype.slice.call(arguments);
		argumentList.splice(0, 1);
		return actionFunction.apply(self, argumentList);
	};

	self.isSettingEnabled = function isSettingEnabled(setting) {
		if (self.dxSession.getRole().roleType === self.RoleTypeEnum.INVIGILATOR) {
			if (setting === DX_INVIGILATOR_SETTINGS.DOWNLOAD_EXAM && !self.exam.canInvigilatorDownload) {
				return false;
			}

			return (self.exam.invigilatorSettings & setting);
		}
		return true;
	};

	// addExamToList calls the addExamToList callback if it was passed to the exam list directive.
	// exam - the exam to add.
	// step - the DX_EXAM_STEPS to which the exam should be added.
	function addExamToList(exam, step) {
		if (self.examlistCtrl.addExamToList) {
			self.examlistCtrl.addExamToList(exam, step);
		}
	}

	// removeExamFromList calls the removeExamFromList callback if it was passed to the exam list directive.
	// exam - the exam to remove.
	// step - the DX_EXAM_STEPS from which the exam should be removed.
	function removeExamFromList(exam, step) {
		if (self.examlistCtrl.removeExamFromList) {
			self.examlistCtrl.removeExamFromList(exam, step);
		}
	}
});
